import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import { style } from "framer-motion/client";

// --- Styled Components ---

const SectionContainer = styled.section`
  padding: 100px 20px;
  /* Light purple gradient background */
  background: #220433;
  overflow: hidden;
  min-height: 100vh;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: clamp(2.5rem, 6vw, 4rem);
    /* Deep purple text for contrast */
    color: #ffffff;
    font-family: "Mendl", sans-serif;
    font-weight: 800;
    letter-spacing: -1px;
    margin: 0;
  }
`;

const VideoGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 40px;
  max-width: 1300px;
  margin: 0 auto;
`;

const VideoCard = styled(motion.div)`
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background: #968c8c;
  aspect-ratio: 9 / 16;
  /* Soft shadow for a modern look */
  box-shadow: 0 20px 40px rgba(74, 48, 128, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.6);
  cursor: pointer;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;
const Socials = styled.div`
  margin-top: 2em;
  h2 {
    color: #b9b5b5;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
  }
  .icons {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3em;
    svg {
      font-size: 3em;
      color: white;
    }
  }
`;

// --- Animation Variants ---

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.25,
    },
  },
};

const cardVariants = {
  hidden: { y: 60, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      // Fixed: x-coordinates must be between 0 and 1
      ease: [0.6, 0.05, 0.01, 0.9],
    },
  },
};

// --- Component ---

const SocialVideoSection = () => {
  const videoIds = [
    "7424531090993433899",
    "7383423392529042730",
    "7424286540769152298",
  ];

  return (
    <SectionContainer>
      <SectionHeader>
        <motion.h2
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Social Vibe
        </motion.h2>
      </SectionHeader>

      <VideoGrid
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
      >
        {videoIds.map((id) => (
          <VideoCard
            key={id}
            variants={cardVariants}
            whileHover={{
              scale: 1.03,
              y: -10,
              boxShadow: "0 30px 60px rgba(74, 48, 128, 0.2)",
            }}
            whileTap={{ scale: 0.98 }}
          >
            <iframe
              src={`https://www.tiktok.com/embed/v2/${id}`}
              allow="fullscreen"
              title={`TikTok Video ${id}`}
              loading="lazy"
            />
          </VideoCard>
        ))}
      </VideoGrid>
      <Socials>
        <h2>Our Socials</h2>
        <div className="icons">
          <Link to={"https://www.instagram.com/nudr.app/"} target="_blank">
            <FaInstagram />
          </Link>
          <Link to={"https://www.tiktok.com/@nudr.app"} target="_blank">
            <FaTiktok />
          </Link>
          <Link to={"https://www.youtube.com/@NudRApp"} target="_blank">
            <FaYoutube />
          </Link>
        </div>
      </Socials>
    </SectionContainer>
  );
};

export default SocialVideoSection;
